import { defineComponent as _defineComponent } from 'vue'
import EditableBlock from '@/components/EditableBlock.vue'
import EditableBlockInput from '@/components/EditableBlockInput.vue'
import MultiSwitch from '@/components/MultiSwitch.vue'
import EventConfigEditor from '@/pages/Manage/Catalogues/components/EventConfigEditor.vue'
import type { CtSupplierCatalogue } from '@/models/interfaces/content-type'
import { computed, onMounted, ref } from 'vue'
import { useQuasar } from 'quasar'
import { useStore } from 'vuex'
import { SYNCABLE_SUPPLIER_SERVICES } from '@/pages/Manage/Catalogues/constants'
import {DirectrSyncTypes} from '@/models/interfaces/catalogue'

import AddIcon from '@/components/Icons/AddIcon.vue'
import ChannelServiceLink from '@/pages/Channels/components/ChannelServiceLink.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SupplierCatalogueSyncSettings',
  props: {
    supplierCatalogue: {}
  },
  emits: ["update:catalogue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const components = {
  AddIcon,
  ChannelServiceLink
}

const props = __props
const emits = __emit

const $q = useQuasar()
const $store = useStore()
const $sys = $store.getters['Services/Sys']

const services = ref<{ id: string, name: string, type: string, [key: string]: any }[]>([])
const showServiceModal = ref(false)
const showServiceConfig = ref(false)
const serviceOptions = computed(() => {
      return services.value
        .filter(service => SYNCABLE_SUPPLIER_SERVICES.includes(service.type))
        .map(({ name, id }) => ({ label: name, value: id }))
    })
onMounted(async () => {
  services.value = (await $sys.get('/service'))
})

const updateService = (editState, serviceId) => {
  if (editState.service) {
    editState.service.id = serviceId
  } else {
    editState.service = {
      id: serviceId,
      sync: {
//        inventory: { active: 0 },
        [DirectrSyncTypes.SourceOrder]: { active: 0 },
        [DirectrSyncTypes.StockItem]: { active: 0 },
      }
    }
  }
}

const syncSwitchOptions = [
  { label: 'off', value: 0 },
  { label: 'pull', value: 1 },
  { label: 'push', value: 2 },
  { label: 'both', value: 3 },
]

const setSync = (editState, editingRef, connectable, value) => {
  if (editState.service?.id) {
    if (!editingRef.value) (editingRef.value = true)
    editState.service.sync[connectable] = { active: value }
  }
}

// watch(() => diffState.rhs, () => emit('diff', !!currentDiff.value))
const onSyncSwitchesClick = (editState, editingRef) => {
  if (!editState.service?.id) {
    if (!editingRef.value) editingRef.value = true
    $q.notify({ message: 'Link to an external app first', type: 'negative', classes: 'custom-notify error' })
  }
}

function createNewService () {
  showServiceModal.value = true
}

const __returned__ = { components, props, emits, $q, $store, $sys, services, showServiceModal, showServiceConfig, serviceOptions, updateService, syncSwitchOptions, setSync, onSyncSwitchesClick, createNewService, EditableBlock, EditableBlockInput, MultiSwitch, EventConfigEditor, computed, onMounted, ref, get useQuasar() { return useQuasar }, get useStore() { return useStore }, get SYNCABLE_SUPPLIER_SERVICES() { return SYNCABLE_SUPPLIER_SERVICES }, get DirectrSyncTypes() { return DirectrSyncTypes }, AddIcon, ChannelServiceLink }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})